import { render, staticRenderFns } from "./PowerUserNavigation.vue?vue&type=template&id=608c0f16"
import script from "./PowerUserNavigation.vue?vue&type=script&lang=js"
export * from "./PowerUserNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports